export enum AuthMethodType {
  Password = 'password',
  Shibboleth = 'shibboleth',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Ldap = 'password',
  Ip = 'ip',
  Oidc = 'oidc',
  Orcid = 'orcid',
  Saml = 'saml',
}
